import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

export function useContacts() {
	/** Hooks */
	const query = useQuery({
		queryKey: ["contacts"],
		queryFn: async () => {
			const response = await client.contacts.index.$get({
				query: {
					includeProjects: "true",
				},
			});
			const data = await responseHandler(response);
			return data.contacts;
		},
	});

	return {
		contacts: query.data,
		...query,
	};
}
